import React from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { Disclosure, Menu } from '@headlessui/react'
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline'
import Cookies from 'js-cookie';
import Swal from 'sweetalert2';
import { BiUserCircle } from 'react-icons/bi';


const navigation = [
    { name: ' Registered Users', href: '/Admin/', current: false },
    { name: ' Tests ', href: '/Admin/AllTests', current: false },
]

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

const TailwindUI = () => {
    const navigate = useNavigate();

    const handlesignout = () => {
        localStorage.removeItem('user');
        localStorage.removeItem('userID');
        Cookies.remove('user');
        Swal.fire({
            icon: 'success',
            title: 'Signed Out',
            text: 'You have been signed out successfully',
            showConfirmButton: false,
            timer: 1500
        }).then(() => {
            navigate('/login');
        })
    }

    return (
        <Disclosure as="nav" className="bg-white text-black">
            {({ open }) => (
                <>
                    <div className="mx-auto max-w-7xl px-2 sm:px-6 lg:px-8">
                        <div className="relative flex h-16 items-center justify-between">
                            <div className="absolute inset-y-0 left-0 flex items-center sm:hidden">
                                {/* Mobile menu button*/}
                                <Disclosure.Button className="inline-flex items-center justify-center rounded-md p-2 text-black hover:bg-gray-700 hover:text-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white">
                                    <span className="sr-only">Open main menu</span>
                                    {open ? (
                                        <XMarkIcon className="block h-6 w-6" aria-hidden="true" />
                                    ) : (
                                        <Bars3Icon className="block h-6 w-6" aria-hidden="true" />
                                    )}
                                </Disclosure.Button>
                            </div>
                            <div className="flex flex-1 items-center justify-center sm:items-stretch sm:justify-start">
                                <div className="flex flex-shrink-0 items-center">
                                    <img
                                        className="block h-8 w-auto lg:hidden"
                                        src={require(`../../assets/MainLogo.webp`)}
                                        alt="US Academy"
                                    />
                                    <img
                                        className="hidden h-8 w-auto lg:block"
                                        src={require(`../../assets/MainLogo.webp`)}
                                        alt="US Academy"
                                    />
                                </div>
                                <div className="hidden sm:ml-6 sm:block">
                                    <div className="flex space-x-4">
                                        {navigation.map((item) => (
                                            <Link
                                                key={item.name}
                                                to={item.href}
                                                className="text-black hover:text-red-900 rounded-md px-3 py-2 text-sm font-medium"
                                            >
                                                {item.name}
                                            </Link>
                                        ))}
                                    </div>
                                </div>
                            </div>
                            <div className="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">


                                {/* Profile dropdown */}
                                <Menu as="div" className="relative ml-3">
                                    <div>
                                        <Menu.Button className="flex rounded-full bg-gray-800 text-sm focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800">
                                            <span className="sr-only">Open user menu</span>
                                            <BiUserCircle className="h-8 w-8 text-white" />
                                        </Menu.Button>
                                    </div>

                                    <Menu.Items className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                                        <Menu.Item>
                                            {({ active }) => (
                                                <button
                                                    onClick={() => {
                                                        Swal.fire({
                                                            title: 'Are you sure?',
                                                            text: "You will need to login again",
                                                            icon: 'warning',
                                                            showCancelButton: true,
                                                            confirmButtonColor: '#3085d6',
                                                            cancelButtonColor: '#d33',
                                                            confirmButtonText: 'Yes, Sign Out!'
                                                        }).then((result) => {
                                                            if (result.isConfirmed) {
                                                                handlesignout()
                                                            }
                                                        }
                                                        )
                                                    }}
                                                    className={classNames(active ? 'bg-gray-100' : '', 'block px-4 py-2 text-sm text-gray-700')}
                                                >
                                                    Sign out
                                                </button>
                                            )}
                                        </Menu.Item>
                                    </Menu.Items>
                                </Menu>
                            </div>
                        </div>
                    </div>

                    <Disclosure.Panel className="sm:hidden">
                        <div className="space-y-1 px-2 pb-3 pt-2">
                            {navigation.map((item) => (
                                <Disclosure.Button
                                    key={item.name}
                                    className={classNames('text-black hover:text-red-900 ',
                                        'block rounded-md px-3 py-2 text-base font-medium'
                                    )}
                                >
                                    <Link to={item.href}>
                                        {item.name}
                                    </Link>
                                </Disclosure.Button>
                            ))}
                        </div>
                    </Disclosure.Panel>
                </>
            )}
        </Disclosure>
    )
}


const Navbar = () => {
    return (
        <div>
            <nav className="bg-gray-800">
                <TailwindUI />
            </nav>
        </div>
    )
}

export default Navbar
